import React from "react";
import PropTypes from "prop-types";
import i18next from "i18next";

import { openCookieSettings } from "../../Utils/gtm";

/**
 * CookieSettingsLink — a small, styleable control that re-opens the cookie
 * consent preferences panel. Drop it in a footer, settings page, or anywhere
 * the user should be able to change their consent (GDPR: withdrawing consent
 * must be as easy as giving it).
 *
 * Renders as a link-style button by default. Pass `className` to restyle.
 */
const CookieSettingsLink = ({ className, label }) => {
  const handleClick = (e) => {
    e.preventDefault();
    openCookieSettings();
  };

  return (
    <a
      href="#cookie-settings"
      onClick={handleClick}
      className={className}
      role="button"
    >
      {label || i18next.t("Cookie settings")}
    </a>
  );
};

CookieSettingsLink.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
};

export default CookieSettingsLink;
